export default __webpack_public_path__ + "static/media/Research2.da5dac6d.png";